$(() => {
  $('#contact-form-submit').on('click', () => {
    $('#contact-form').trigger('submit');
  });

  _validator = $('#contact-form').validate({
    ignore: [],
    onfocusout(element) {
      $(element).valid();
    },
    rules: {
      first_name: {
        required: true,
      },
      job_title: {
        required: true,
      },
      industry: {
        required: true,
      },
      last_name: {
        required: true,
      },
      work_phone: {
        required: true,
      },
      contact_method: {
        required: true,
      },
      company: {
        required: true,
      },
      work_email: {
        required: true,
        email: true,
      },
      how_help: {
        required: true,
      },
    },
    messages: {
      first_name: {
        required: 'First Name is required.',
      },
      job_title: {
        required: 'Job Title is required.',
      },
      industry: {
        required: 'Industry is required.',
      },
      last_name: {
        required: 'Last Name is required.',
      },
      work_phone: {
        required: 'Phone is required.',
      },
      contact_method: {
        required: 'This field is required.',
      },
      company: {
        required: 'Company is required.',
      },
      work_email: {
        required: 'Email is required.',
      },
      how_help: {
        required: 'This field is required.',
      },
    },
    highlight(element) {
      $(element).closest('div').addClass('error').removeClass('valid');
    },
    unhighlight(element) {
      $(element).closest('div').removeClass('error').addClass('valid');
    },
    errorPlacement(error, element) {
      const message = error.html();

      if (message.length > 0) {
        $(element[0]).closest('div.error').append(error);
      }
    },
    // ---------------------------------------------------- FORM SUBMIT HANDLER //
    submitHandler() {
      $('#contact-form-submit').attr('disabled', 'disabled');

      $.ajax({
        url: '/ajax/contactus/submit',
        type: 'POST',
        dataType: 'json',
        data: $('form').serialize(),
      })
        .done(response => {
          console.log({ response });
          if (!response.err) {
            $('#contact-form-submit').fadeOut('fast');
            $('#contact-form').fadeOut('fast', () => {
              $('#contact-form-thankyou').fadeIn('fast');
            });
          }
          else {
            alert(response.msg);
            $('#contact-form-submit').removeAttr('disabled');
          }
        })
        .fail(response => {
          console.error({ response });
          $('#contact-form-submit').removeAttr('disabled');
        });
    },
  });
});
